/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { GetService, PostService } from "../../../Services/ConstantService";
import { API_URL } from "../../../Services/ApiService";
import { BounceLoader } from "react-spinners";
import { format, parseISO } from "date-fns";
import { showWarningAlert, toastEmmit } from "../../../Helper/Toastr";
// import html2canvas from "html2canvas";
// import jsPDF from "jspdf";
import html2pdf from 'html2pdf.js';

export default function OrderDetails() {
  const navigate = useNavigate();
  const params = useParams(); 

  const [Loading, setLoading] = useState(false);
  const [DataObj, setDataObj] = useState([]);
  const [cancelTime, setCancelTime] = useState("");
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [remainingTime, setRemainingTime] = useState("");

  useEffect(() => {
    const time = DataObj?.billingData?.created_at;

    if (time) {
      const createTime = new Date(time).getTime();
      const currentTime = new Date().getTime();
      const timeDiff = currentTime - createTime;
      const twentyFourHoursInMs = 24 * 60 * 60 * 1000;

      if (timeDiff < twentyFourHoursInMs) {
        setIsButtonEnabled(true);
        const timeRemaining = twentyFourHoursInMs - timeDiff;
        setRemainingTime(timeRemaining);
        const interval = setInterval(() => {
          setRemainingTime((prevTime) => prevTime - 1000);
        }, 1000);
        setCancelTime(interval);
      } else {
        setIsButtonEnabled(false);
      }
    }
    return () => clearTimeout(cancelTime);
  }, [DataObj]);

  const formatTime = (ms) => {
    const seconds = Math.floor((ms / 1000) % 60);
    const minutes = Math.floor((ms / (1000 * 60)) % 60);
    const hours = Math.floor((ms / (1000 * 60 * 60)) % 24);
    return `${hours}h ${minutes}m ${seconds}s`;
  };

  const status = [
    {
      status_name: "Order Placed",
      status_class: "fa-solid fa-bag-shopping",
      tracking_no: 0,
    },
    {
      status_name: "Creating Order",
      status_class: "fa-solid fa-gift",
      tracking_no: 1,
    },
    {
      status_name: "Shipping",
      status_class: "fa-solid fa-truck",
      tracking_no: 2,
    },
    {
      status_name: "Out For Delivery",
      status_class: "fa-solid fa-truck-fast",
      tracking_no: 3,
    },
    {
      status_name: "Delivered",
      status_class: "fa-solid fa-truck-ramp-box",
      tracking_no: 4,
    },
  ];

  useEffect(() => {
    GetOrderDetails();
  }, []);

  const GetOrderDetails = () => {
    setLoading(true);
    GetService(`${API_URL.GET_ORDER_DETAIL}?id=${params?.id}`).then((res) => {
      console.log(res);
      if (res?.data?.status) {
        setDataObj(res?.data?.data);
      }
      setLoading(false);
    });
  };

  function navigatetoList() {
    navigate("/profile-dashboard/my-orders");
  }

  const [imageloading, setimageloading] = useState(true);

  const handleImageLoad = () => {
    setimageloading(false);
  };

  const CancelOrder = () => {
    setLoading(true);
    PostService(API_URL.CANCEL_ORDER, {
      orderId: DataObj?.billingData?.id,
      order_no: DataObj?.billingData?.order_no,
      phoneNumber: DataObj?.billingData?.bphone,
      status: "Cancel Order",
      orderMessage: "Order has been cancelled!",
      changed_by: "user",
    }).then((res) => {
      console.log(res);
      if (res?.data?.status) {
        toastEmmit("success", "Order cancelled successfully");
        GetOrderDetails();
      }
      setLoading(false);
    });
  };

  function gettrackingNumber(curstatus) {
    const trackingNumber = status?.findIndex(
      (i) => i.status_name === curstatus
    );
    // console.log(trackingNumber)
    // if (trackingNumber) {
    return trackingNumber;
    // }
  }

  // const downloadInvoice = async () => {
  //   setLoading(true)
  //   const element = document.getElementById('divToPrint');
  //   element.classList.remove('d-none');
  //   // const canvas = await html2canvas(element, { useCORS: true });
  //   // const imgData = canvas.toDataURL('image/png');
  //   // const pdf = new jsPDF('p', 'mm', 'a4');
   

  //   // const imgProps = pdf.getImageProperties(imgData);
  //   // const pdfWidth = pdf.internal.pageSize.getWidth();
  //   // const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

  //   // pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
  //   // pdf.save('invoice.pdf');

  //   const opt = {
  //     margin: 0,
  //     filename: 'invoice.pdf',
  //     image: { type: 'jpeg', quality: 0.98 },
  //     html2canvas: { scale: 2 },
  //     jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
  //   };
  
  //   // Use html2pdf to create and download the PDF
  //   try {
  //     await html2pdf().from(element).set(opt).save();
  //   } catch (error) {
  //     console.error('Error generating PDF:', error);
  //   }

  //   element.classList.add('d-none');
  //   setLoading(false)
  // };
 
  const downloadInvoice = async () => {
    setLoading(true);
    await handleDownload();
    setLoading(false);
  };

  const handleDownload = async () => {
    setLoading(true);
    const element = document.getElementById('divToPrint');
    
    // Temporarily make the element visible
    element.classList.remove('d-none');
  
    const opt = {
      margin: 0, // margins around the content
      filename: 'invoice.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
      pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
    };
  
    try {
      // Use html2pdf to create and download the PDF
      await html2pdf().from(element).set(opt).save();
    } catch (error) {
      console.error('Error generating PDF:', error);
    }
  
    // Hide the element again
    element.classList.add('d-none');
    setLoading(false);
  };

  return (
    <div className="h-same">
      <div
        className="tab-pane fade active show"
        id="nav-Brochure"
        role="tabpanel"
        aria-labelledby="nav-Brochure-tab"
        tabIndex={0}
      >
        <div className="tp-best-product-4__item-box">
          <div className="row">
            <div className="col-xl-12 col-lg-12 col-md-6">
              <div className="heading d-flex justify-content-between align-items-center">
                <p>
                  <span onClick={navigatetoList}>
                    <i
                      className="fa-solid fa-arrow-left pointer mr-10"
                      style={{ color: "#1f4cde" }}
                    ></i>
                  </span>{" "}
                  Order Details
                </p>
                <div className="mr-20 fw-semibold">
                  Order-{" "}
                  <span className="text-primary">
                    {DataObj?.billingData?.order_no}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-between my-4">
            <div className=" ">
              <ul className="pl-10">
                <li className="px-1 pb-1" style={{ fontSize: 16 }}>
                  <label className="fw-bold me-2">Name : </label>{" "}
                  {DataObj?.billingData?.bfname} {DataObj?.billingData?.blname}
                </li>
                <li className="px-1 pb-1" style={{ fontSize: 16 }}>
                  <label className="fw-bold me-2">Email : </label>{" "}
                  {DataObj?.billingData?.bemailid}
                </li>
                <li className="px-1 pb-1" style={{ fontSize: 16 }}>
                  <label className="fw-bold me-2">Contact : </label>
                  {DataObj?.billingData?.bphone}
                </li>
                <li className="px-1 pb-1" style={{ fontSize: 16 }}>
                  <label className="fw-bold me-2">Shipping Address :</label>
                  <br />
                  {DataObj?.billingData?.saddress1},
                </li>
                <li className="px-1 pb-1" style={{ fontSize: 16 }}>
                  {DataObj?.billingData?.scity} ({DataObj?.billingData?.szip}),
                </li>
                <li className="px-1 pb-1" style={{ fontSize: 16 }}>
                  {DataObj?.SState?.state_name} ,{" "}
                  {DataObj?.SCountry?.country_name}
                </li>
                {/* <li className="px-1 pb-1" style={{ fontSize: 16 }}>
                  ({DataObj?.billingData?.bzip})
                </li> */}
              </ul>
            </div>

            <div className=" me-3">
              <ul>
                <li className="px-1 pb-1" style={{ fontSize: 15 }}>
                  <label className="fw-bold me-2">Transaction Id : </label>{" "}
                  {DataObj?.paymentData?.transaction_id}
                </li>
                <li className="px-1 pb-1" style={{ fontSize: 15 }}>
                  <label className="fw-bold me-2">Order Date: </label>
                  {DataObj?.paymentData?.created_at
                    ? format(
                        parseISO(DataObj?.paymentData?.created_at),
                        "dd-MM-yyyy HH:mm"
                      )
                    : ""}
                </li>
                <li className="px-1 pb-1" style={{ fontSize: 15 }}>
                  <label className="fw-bold me-2">Payment Mode : </label>
                  <span className="text-uppercase">
                    {DataObj?.paymentData?.payment_method}
                  </span>
                </li>
                <li className="px-1 pb-1" style={{ fontSize: 15 }}>
                  <label className="fw-bold me-2">Payment Status : </label>
                  <span className="text-uppercase">
                    {DataObj?.paymentData?.status}
                  </span>
                </li>
                <li className="px-1 pb-1" style={{ fontSize: 15 }}>
                  <label className="fw-bold me-2">Order Status : </label>
                  <span
                    className={`text-uppercase fw-semibold ${
                      DataObj?.billingData?.order_status === "Cancel Order"
                        ? "text-danger"
                        : DataObj?.billingData?.order_status === "Delivered"
                        ? "text-success"
                        : "text-primary"
                    }`}
                  >
                    {DataObj?.billingData?.order_status === "Cancel Order"
                      ? "Cancelled"
                      : DataObj?.billingData?.order_status}
                  </span>
                </li>
                <li className="px-1 pb-1" style={{ fontSize: 15 }}>
                  <label className="fw-bold me-2">Total Amount : </label>
                  <span className="text-danger fw-semibold">
                    $
                    {parseFloat(
                      DataObj?.billingData?.total_amount
                    ).toLocaleString()}
                  </span>
                </li>
              </ul>
              <div className="btn btn-primary mt-2 text-end btn-sm" onClick={downloadInvoice}>Download Invoice</div>
            </div>
          </div>

          <div className="row row-cols-1 row-cols-lg-1 row-cols-xl-1  mt-2 row-cols-equal-space detail-page">
            <div className="col-lg-12 col-12 col-md-12  ">
              <div className=" table-responsive   first-li">
                <table className="table">
                  <thead className="bgLightSecondary">
                    <tr>
                      <th className="orderDetailtable table-th">Preview</th>
                      <th
                        className="orderDetailtable table-th"
                        style={{ width: "310px" }}
                      >
                        Product
                      </th>
                      <th className="orderDetailtable table-th">Item Price</th>
                      <th className="orderDetailtable table-th">Quantity</th>
                      <th className="orderDetailtable table-th">
                        Edge/Services
                      </th>
                      <th className="orderDetailtable table-th">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {DataObj &&
                      DataObj?.billingData?.orderItems?.map((data, index) => (
                        <tr key={index}>
                          <td
                            className="p-2"
                            // style={{
                            //   width: "165px",
                            //   display: "flex",
                            //   justifyContent: "center",
                            //   alignItems: "center",
                            // }}
                          >
                            {imageloading && (
                              <div className="h-100 align-items-center d-flex justify-content-center mt-4">
                                <i
                                  className="fa fa-spinner fa-pulse fa-2x fa-fw"
                                  style={{ animationDuration: "1.5s" }}
                                ></i>
                              </div>
                            )}
                            <img
                              src={
                                data?.gift_card_Details
                                  ? data?.gift_card_Details?.image
                                  : data?.MergedImage
                              }
                              alt=""
                              onLoad={handleImageLoad}
                              style={{
                                display: imageloading ? "none" : "block",
                                width: "100px",
                                height: "95px",
                                objectFit: "contain ",
                              }}
                              onError={(e) => {
                                setimageloading(false);
                                e.target.src = "assets/img/blog/bop-1.png";
                              }}
                            />
                          </td>
                          {data?.gift_card_Details ? (
                            <td className="p-2">
                              <ul>
                                <li className="p-1 fw-semibold text-primary">
                                  {data?.gift_card_Details?.name}
                                </li>
                                <li
                                  className="px-1 pb-1"
                                  style={{ fontSize: "12px" }}
                                >
                                  {data?.gift_card_Details?.description}
                                </li>
                              </ul>
                            </td>
                          ) : (
                            <td className="p-2">
                              <ul>
                                <li className="p-1 fw-semibold text-primary">
                                  {" "}
                                  {data?.Layout === "gallery_wall"
                                    ? "Gallery Wall"
                                    : data?.Layout === "story_canvas"
                                    ? "Story Canvas"
                                    : data?.Layout === "split_canvas"
                                    ? "Split Canvas"
                                    : data?.Layout === "single_panel"
                                    ? "Single Canvas"
                                    : data?.Layout === "plexi_print"
                                    ? "Plexi Print"
                                    : data?.Layout === "art_tray"
                                    ? "Art Tray"
                                    : data?.Layout === "wood_print"
                                    ? "Wood Print"
                                    : data?.Layout === "diamond_dust"
                                    ? "Diamond Dust"
                                    : data?.Layout}
                                </li>
                                {data?.Layout === "single_panel" && (
                                  <li
                                    className="px-1 pb-1"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {data?.type === "framed"
                                      ? "Framed"
                                      : data?.type === "thinGallery"
                                      ? "Thin Gallery Wrap (0.75)"
                                      : data?.type === "thickGallery"
                                      ? "Thick Gallery Wrap (1.5)"
                                      : data?.type === "rolled"
                                      ? "Rolled in a Tube"
                                      : ""}
                                  </li>
                                )}
                                {data?.Layout === "split_canvas" && (
                                  <li
                                    className="px-1 pb-1"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {data?.size_detail?.panels === 2
                                      ? "DYPTYCHS"
                                      : "TRYPTYCHS"}{" "}
                                    -{" "}
                                    {data?.size_detail?.price
                                      ? "Standard 3/4"
                                      : "Thick 1 1/2"}
                                  </li>
                                )}
                                <li className="px-1 pb-1">
                                  {" "}
                                  {data?.size_detail?.size}
                                </li>
                                {data?.Edge && JSON.parse(data?.Edge)?.edge && (
                                  <li
                                    className="px-1 pb-1"
                                    style={{ fontSize: "13px" }}
                                  >
                                    <label className="fw-bold">Edge: </label>{" "}
                                    {JSON.parse(data?.Edge)?.edge} ($
                                    {JSON.parse(data?.Edge)?.price || 0})
                                  </li>
                                )}

                                {JSON.parse(data?.Services)?.Effects?.name && (
                                  <li
                                    className="px-1 pb-1"
                                    style={{ fontSize: "13px" }}
                                  >
                                    <label className="fw-bold">Effects: </label>{" "}
                                    {JSON.parse(data?.Services)?.Effects?.name}{" "}
                                    ($
                                    {JSON.parse(data?.Services)?.Effects
                                      ?.price || 0}{" "}
                                    {JSON.parse(data?.Services)?.Effects
                                      ?.name === "Textured Canvas Coating" &&
                                      "sq inch"}
                                    )
                                  </li>
                                )}
                                {JSON.parse(data?.Services)?.Retouching
                                  ?.name && (
                                  <li
                                    className="px-1 pb-1"
                                    style={{ fontSize: "13px" }}
                                  >
                                    <label className="fw-bold">
                                      Retouching:{" "}
                                    </label>{" "}
                                    {
                                      JSON.parse(data?.Services)?.Retouching
                                        ?.name
                                    }{" "}
                                    ($
                                    {JSON.parse(data?.Services)?.Retouching
                                      ?.price || 0}
                                    )
                                  </li>
                                )}
                                {data?.size_detail?.suggested_Items &&
                                  <li className="px-1 pb-1">
                                    <small>{"(Excluded discount)"}</small>
                                </li>
                                }
                              </ul>
                            </td>
                          )}
                          <td className="p-2">
                            <span className="p-1">
                              $
                              {data?.size_detail?.thick_price
                                ? data?.size_detail?.thick_price
                                : data?.size_detail?.price}
                            </span>
                          </td>
                          <td className="text-center p-2">
                            <span className="p-1">{data?.quantity}</span>
                          </td>
                          <td className="p-2 ps-4">
                            <span className="p-1">
                              ${data?.additionalprice}
                            </span>
                          </td>
                          <td className="p-2">
                            <span className="text-primary">
                              ${data?.price.toLocaleString()}
                            </span>
                          </td>
                        </tr>
                      ))}
                    <tr className="border-top border-top-dashed">
                      <td colspan="2">
                        <ul>
                          <li className="px-1 pb-1" style={{ fontSize: 16 }}>
                            <label className="fw-bold me-2 text-muted">
                              Billing Address{" "}
                            </label>{" "}
                            <br />
                            {DataObj?.billingData?.baddress1},
                          </li>
                          <li className="px-1 pb-1" style={{ fontSize: 16 }}>
                            {DataObj?.billingData?.bcity} (
                            {DataObj?.billingData?.bzip}),
                          </li>
                          <li className="px-1 pb-1" style={{ fontSize: 16 }}>
                            {DataObj?.BState?.state_name},{" "}
                            {DataObj?.BCountry?.country_name}
                          </li>
                        </ul>
                      </td>
                      <td colspan="4" className="fw-medium p-0">
                        <table className="table table-borderless mb-0">
                          <tbody>
                            <tr>
                              <td>Sub Total :</td>
                              <td className="pe-4 text-end text-primary">
                                $
                                {parseFloat(
                                  DataObj?.billingData?.orderSummery?.subtotal
                                ).toLocaleString() || 0}
                              </td>
                            </tr>
                            <tr>
                              <td className="py-0">Shipping Charge :</td>
                              <td className="py-0 pe-4 text-end">
                                {" "}
                                $
                                {(
                                  DataObj?.billingData?.orderSummery
                                    ?.shippingprice || 0
                                ).toFixed(2)}{" "}
                              </td>
                            </tr>
                            <tr>
                              <td className="">
                                Discount
                                <span className="text-muted">
                                  {DataObj?.billingData?.promoCode
                                    ? `(${DataObj?.billingData?.promoCode})`
                                    : ""}{" "}
                                  :
                                </span>
                              </td>
                              <td className="pe-4 text-end">
                                - $
                                {DataObj?.billingData?.orderSummery?.discount ||
                                  0}
                              </td>
                            </tr>
                            {/* <tr>
                              <td className="pb-2 pt-0">Estimated Tax :</td>
                              <td className="pb-2 pt-0">$44.99</td>
                            </tr> */}
                            <tr className="border-top border-top-dashed">
                              <th scope="row" className="px-4">
                                Total (USD) :
                              </th>
                              <th className="pe-4 text-end">
                                $
                                {parseFloat(
                                  DataObj?.billingData?.orderSummery?.total
                                ).toLocaleString() || 0}
                              </th>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
                {DataObj?.billingData?.order_status === "Cancel Order" &&
                  DataObj?.billingData?.changed_by === "admin" && (
                    <div className="text-danger text-center fw-semibold pb-10">
                      Order Cancelled due to- (
                      {DataObj?.billingData?.order_message})
                    </div>
                  )} 
              </div> 
            </div>
          </div>
          <div className="row">
            {DataObj?.billingData?.order_status !== "Cancel Order" && (
              <div className="my-2">
                <h5 className="px-3 fw-semibold primaryblue">Order Status</h5>
                <div className="row  ">
                  {DataObj?.billingData?.order_status !== "Cancel Order" && (
                    <div className="col-12">
                      <ul id="progressbar" class="text-center">
                        {status &&
                          DataObj?.billingData?.order_status !==
                            "Cancel Order" &&
                          status?.map((item, i) => (
                            <li
                              class={`step0 ${
                                gettrackingNumber(
                                  DataObj?.billingData?.order_status
                                ) >= i
                                  ? "active"
                                  : ""
                              }`}
                            >
                              <i class={item?.status_class}></i>{" "}
                              {item?.status_name}
                            </li>
                          ))}
                      </ul>
                    </div>
                  )}
                </div>
                <div>
                  <p
                    className={`text-center ${
                      DataObj?.billingData?.order_status === "Cancel Order"
                        ? "text-danger"
                        : DataObj?.billingData?.order_status === "Delivered"
                        ? "text-success"
                        : "text-primary"
                    } fw-semibold`}
                  >
                    {DataObj?.billingData?.order_message}
                  </p>
                </div>

                <hr />
              </div>
            )}
          </div>

          <div className="row">
            {DataObj?.billingData?.order_status !== "Cancel Order" &&
              DataObj?.billingData?.delivery_id > 0 && (
                <div className="my-2">
                  <h5 className="px-3 fw-semibold primaryblue">
                    Delivery Partner Details
                  </h5>
                  <div>
                    <ul className="pl-10">
                      <li>
                        <img
                          src={
                            DataObj?.billingData?.delivery_partner
                              ?.delivery_partner_logo
                          }
                          alt="..."
                          style={{
                            height: "100px",
                            width: "100px",
                            objectFit: "contain",
                          }}
                        />
                      </li>
                      <li className="px-1 pb-1" style={{ fontSize: 16 }}>
                        <label className="fw-bold me-2">Name : </label>{" "}
                        {DataObj?.billingData?.delivery_partner?.name}
                      </li>
                      <li className="px-1 pb-1" style={{ fontSize: 16 }}>
                        <label className="fw-bold me-2">Email : </label>{" "}
                        {DataObj?.billingData?.delivery_partner?.email}
                      </li>
                      <li className="px-1 pb-1" style={{ fontSize: 16 }}>
                        <label className="fw-bold me-2">Contact : </label>
                        {DataObj?.billingData?.delivery_partner?.phoneNumber}
                      </li>
                    </ul>
                  </div>
                </div>
              )}

            {DataObj?.billingData?.order_status !== "Cancel Order" &&
              isButtonEnabled && (
                <>
                  <div className="d-flex justify-content-end align-items-end">
                    <small className="me-1">
                      (Cancel time expires within{" "}
                      <span className="text-primary">
                        {formatTime(remainingTime)}
                      </span>
                      )
                    </small>
                    <button
                      className="btn btn-danger float-end rounded-0 btn-sm"
                      onClick={() => showWarningAlert(CancelOrder)}
                    >
                      Cancel Order
                    </button>
                  </div>
                </>
              )}
          </div>
        </div>
      </div>

      {/* ---------------------------------- INVOICE ----------------------------------- */}

      <div className="mt-5">
         
        <div className="py-3 d-none" id="divToPrint">
          <div className="tp-best-product-4__item-box px-2">
            <h5 className="text-center text-muted">Tax Invoice</h5>
            <div className="d-flex justify-content-between ">
              <div className=" ">
                <img
                  src="assets/img/logo/logo.png"
                  alt="..."
                  className="pl-10"
                />
                <ul className="pl-10 mt-20">
                  <li className="px-1 pb-1" style={{ fontSize: 16 }}>
                    <label className="fw-bold me-2">Name : </label>{" "}
                    {DataObj?.billingData?.bfname}{" "}
                    {DataObj?.billingData?.blname}
                  </li>
                  <li className="px-1 pb-1" style={{ fontSize: 16 }}>
                    <label className="fw-bold me-2">Email : </label>{" "}
                    {DataObj?.billingData?.bemailid}
                  </li>
                  <li className="px-1 pb-1" style={{ fontSize: 16 }}>
                    <label className="fw-bold me-2">Contact : </label>
                    {DataObj?.billingData?.bphone}
                  </li>
                </ul>
              </div>

              <div className=" me-3">
                <ul>
                  <li className="px-1 pb-1" style={{ fontSize: 15 }}>
                    <label className="fw-bold me-2">Order No : </label>
                    <span className="text-primary fw-semibold">
                      {DataObj?.billingData?.order_no}
                    </span>
                  </li>
                  <li className="px-1 pb-1" style={{ fontSize: 15 }}>
                    <label className="fw-bold me-2">Transaction Id : </label>{" "}
                    {DataObj?.paymentData?.transaction_id}
                  </li>
                  <li className="px-1 pb-1" style={{ fontSize: 15 }}>
                    <label className="fw-bold me-2">Order Date: </label>
                    {DataObj?.paymentData?.created_at
                      ? format(
                          parseISO(DataObj?.paymentData?.created_at),
                          "dd-MM-yyyy HH:mm"
                        )
                      : ""}
                  </li>
                  <li className="px-1 pb-1" style={{ fontSize: 15 }}>
                    <label className="fw-bold me-2">Payment Mode : </label>
                    <span className="text-uppercase">
                      {DataObj?.paymentData?.payment_method}
                    </span>
                  </li>
                  <li className="px-1 pb-1" style={{ fontSize: 15 }}>
                    <label className="fw-bold me-2">Payment Status : </label>
                    <span className="text-uppercase">
                      {DataObj?.paymentData?.status}
                    </span>
                  </li>
                  <li className="px-1 pb-1" style={{ fontSize: 15 }}>
                    <label className="fw-bold me-2">Order Status : </label>
                    <span
                      className={`text-uppercase fw-semibold ${
                        DataObj?.billingData?.order_status === "Cancel Order"
                          ? "text-danger"
                          : DataObj?.billingData?.order_status === "Delivered"
                          ? "text-success"
                          : "text-primary"
                      }`}
                    >
                      {DataObj?.billingData?.order_status === "Cancel Order"
                        ? "Cancelled"
                        : DataObj?.billingData?.order_status}
                    </span>
                  </li>
                  <li className="px-1 pb-1" style={{ fontSize: 15 }}>
                    <label className="fw-bold me-2">Total Amount : </label>
                    <span className="text-danger fw-semibold">
                      $
                      {parseFloat(
                        DataObj?.billingData?.total_amount
                      ).toLocaleString()}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <hr className="my-1" />

            <div className="d-flex">
              <div className="col-6">
                <ul className="pl-10">
                  <li className="px-1 pb-1" style={{ fontSize: 16 }}>
                    <label className="fw-bold me-2">Shipping Address :</label>
                    <br />
                    {DataObj?.billingData?.saddress1},
                  </li>
                  <li className="px-1 pb-1" style={{ fontSize: 16 }}>
                    {DataObj?.billingData?.scity} ({DataObj?.billingData?.szip}
                    ),
                  </li>
                  <li className="px-1 pb-1" style={{ fontSize: 16 }}>
                    {DataObj?.SState?.state_name} ,{" "}
                    {DataObj?.SCountry?.country_name}
                  </li>
                </ul>
              </div>

              <div className="col-6 pl-100">
                <ul>
                  <li className="px-1 pb-1" style={{ fontSize: 16 }}>
                    <label className="fw-bold me-2 text-muted">
                      Billing Address{" "}
                    </label>{" "}
                    <br />
                    {DataObj?.billingData?.baddress1},
                  </li>
                  <li className="px-1 pb-1" style={{ fontSize: 16 }}>
                    {DataObj?.billingData?.bcity} ({DataObj?.billingData?.bzip}
                    ),
                  </li>
                  <li className="px-1 pb-1" style={{ fontSize: 16 }}>
                    {DataObj?.BState?.state_name},{" "}
                    {DataObj?.BCountry?.country_name}
                  </li>
                </ul>
              </div>
            </div>
            <hr />

            <div className="row row-cols-1 row-cols-lg-1 row-cols-xl-1 mb-40 mt-2 row-cols-equal-space detail-page">
              <div className="col-lg-12 col-12 col-md-12  ">
                <div className=" table-responsive   first-li">
                  <table className="table">
                    <thead className="bgLightSecondary">
                      <tr>
                        {/* <th className="orderDetailtable table-th">Preview</th> */}
                        <th
                          className="orderDetailtable table-th"
                          style={{ width: "310px" }}
                        >
                          Product
                        </th>
                        <th className="orderDetailtable table-th">
                          Item Price
                        </th>
                        <th className="orderDetailtable table-th">Quantity</th>
                        <th className="orderDetailtable table-th">
                          Edge/Services
                        </th>
                        <th className="orderDetailtable table-th">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {DataObj &&
                        DataObj?.billingData?.orderItems?.map((data, index) => (
                          <tr key={index}>
                            {/* <td
                              className="p-2"
                              // style={{
                              //   width: "165px",
                              //   display: "flex",
                              //   justifyContent: "center",
                              //   alignItems: "center",
                              // }}
                            >
                              {imageloading && (
                                <div className="h-100 align-items-center d-flex justify-content-center mt-4">
                                  <i
                                    className="fa fa-spinner fa-pulse fa-2x fa-fw"
                                    style={{ animationDuration: "1.5s" }}
                                  ></i>
                                </div>
                              )}
                              <img
                                src={
                                  data?.gift_card_Details
                                    ? data?.gift_card_Details?.image
                                    : data?.MergedImage 
                                }
                                alt=""
                                onLoad={handleImageLoad}
                                style={{
                                  display: imageloading ? "none" : "block",
                                  width: "100px",
                                  height: "95px",
                                  objectFit: "contain ",
                                }}
                                onError={(e) => {
                                  setimageloading(false);
                                  e.target.src = "assets/img/blog/bop-1.png";
                                }}
                              />
                            </td> */}
                            {data?.gift_card_Details ? (
                              <td className="p-2">
                                <ul>
                                  <li className="p-1 fw-semibold text-primary">
                                    {data?.gift_card_Details?.name}
                                  </li>
                                  <li
                                    className="px-1 pb-1"
                                    style={{ fontSize: "12px" }}
                                  >
                                    {data?.gift_card_Details?.description}
                                  </li>
                                </ul>
                              </td>
                            ) : (
                              <td className="p-2">
                                <ul>
                                  <li className="p-1 fw-semibold text-primary">
                                    {" "}
                                    {data?.Layout === "gallery_wall"
                                      ? "Gallery Wall"
                                      : data?.Layout === "story_canvas"
                                      ? "Story Canvas"
                                      : data?.Layout === "split_canvas"
                                      ? "Split Canvas"
                                      : data?.Layout === "single_panel"
                                      ? "Single Canvas"
                                      : data?.Layout === "plexi_print"
                                      ? "Plexi Print"
                                      : data?.Layout === "art_tray"
                                      ? "Art Tray"
                                      : data?.Layout === "wood_print"
                                      ? "Wood Print"
                                      : data?.Layout === "diamond_dust"
                                      ? "Diamond Dust"
                                      : data?.Layout}
                                  </li>
                                  {data?.Layout === "single_panel" && (
                                    <li
                                      className="px-1 pb-1"
                                      style={{ fontSize: "14px" }}
                                    >
                                      {data?.type === "framed"
                                        ? "Framed"
                                        : data?.type === "thinGallery"
                                        ? "Thin Gallery Wrap (0.75)"
                                        : data?.type === "thickGallery"
                                        ? "Thick Gallery Wrap (1.5)"
                                        : data?.type === "rolled"
                                        ? "Rolled in a Tube"
                                        : ""}
                                    </li>
                                  )}
                                  {data?.Layout === "split_canvas" && (
                                    <li
                                      className="px-1 pb-1"
                                      style={{ fontSize: "14px" }}
                                    >
                                      {data?.size_detail?.panels === 2
                                        ? "DYPTYCHS"
                                        : "TRYPTYCHS"}{" "}
                                      -{" "}
                                      {data?.size_detail?.price
                                        ? "Standard 3/4"
                                        : "Thick 1 1/2"}
                                    </li>
                                  )}
                                  <li className="px-1 pb-1">
                                    {" "}
                                    {data?.size_detail?.size}
                                  </li>
                                  {data?.Edge &&
                                    JSON.parse(data?.Edge)?.edge && (
                                      <li
                                        className="px-1 pb-1"
                                        style={{ fontSize: "13px" }}
                                      >
                                        <label className="fw-bold">
                                          Edge:{" "}
                                        </label>{" "}
                                        {JSON.parse(data?.Edge)?.edge} ($
                                        {JSON.parse(data?.Edge)?.price || 0})
                                      </li>
                                    )}

                                  {JSON.parse(data?.Services)?.Effects
                                    ?.name && (
                                    <li
                                      className="px-1 pb-1"
                                      style={{ fontSize: "13px" }}
                                    >
                                      <label className="fw-bold">
                                        Effects:{" "}
                                      </label>{" "}
                                      {
                                        JSON.parse(data?.Services)?.Effects
                                          ?.name
                                      }{" "}
                                      ($
                                      {JSON.parse(data?.Services)?.Effects
                                        ?.price || 0}{" "}
                                      {JSON.parse(data?.Services)?.Effects
                                        ?.name === "Textured Canvas Coating" &&
                                        "sq inch"}
                                      )
                                    </li>
                                  )}
                                  {JSON.parse(data?.Services)?.Retouching
                                    ?.name && (
                                    <li
                                      className="px-1 pb-1"
                                      style={{ fontSize: "13px" }}
                                    >
                                      <label className="fw-bold">
                                        Retouching:{" "}
                                      </label>{" "}
                                      {
                                        JSON.parse(data?.Services)?.Retouching
                                          ?.name
                                      }{" "}
                                      ($
                                      {JSON.parse(data?.Services)?.Retouching
                                        ?.price || 0}
                                      )
                                    </li>
                                  )}
                                  {data?.size_detail?.suggested_Items &&
                                  <li className="px-1 pb-1">
                                    <small>{"(Excluded discount)"}</small>
                                </li>
                                }
                                </ul>
                              </td>
                            )}
                            <td className="p-2">
                              <span className="p-1">
                                $
                                {data?.size_detail?.thick_price
                                ? data?.size_detail?.thick_price
                                : data?.size_detail?.price}
                              </span>
                            </td>
                            <td className="text-center p-2">
                              <span className="p-1">{data?.quantity}</span>
                            </td>
                            <td className="p-2 ps-4">
                              <span className="p-1">
                                ${data?.additionalprice}
                              </span>
                            </td>
                            <td className="p-2">
                              <span className="text-primary fw-semibold">
                                ${data?.price.toLocaleString()}
                              </span>
                            </td>
                          </tr>
                        ))}
                      <tr className="border-top border-top-dashed">
                        <td colspan="2"></td>
                        <td colspan="4" className="fw-medium p-0">
                          <table className="table table-borderless mb-0">
                            <tbody>
                              <tr>
                                <td>Sub Total :</td>
                                <td className="pe-4 text-end text-primary fw-semibold">
                                  $
                                  {parseFloat(
                                    DataObj?.billingData?.orderSummery?.subtotal
                                  ).toLocaleString() || 0}
                                </td>
                              </tr>
                              <tr>
                                <td className="py-0">Shipping Charge :</td>
                                <td className="py-0 pe-4 text-end">
                                  {" "}
                                  $
                                  {(
                                    DataObj?.billingData?.orderSummery
                                      ?.shippingprice || 0
                                  ).toFixed(2)}{" "}
                                </td>
                              </tr>
                              <tr>
                                <td className="">
                                  Discount
                                  <span className="text-muted">
                                    {DataObj?.billingData?.promoCode
                                      ? `(${DataObj?.billingData?.promoCode})`
                                      : ""}{" "}
                                    :
                                  </span>
                                </td>
                                <td className="pe-4 text-end">
                                  - $
                                  {DataObj?.billingData?.orderSummery
                                    ?.discount || 0}
                                </td>
                              </tr>
                              <tr className="border-top border-top-dashed text-bg-primary">
                                <th scope="row" className="px-4">
                                  Grand Total (USD) :
                                </th>
                                <th className="pe-4 text-end">
                                  $
                                  {parseFloat(
                                    DataObj?.billingData?.orderSummery?.total
                                  ).toLocaleString() || 0}
                                </th>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table> 
                </div>
              </div>
            </div> 
          </div>
        </div>
      </div>

      {Loading ? (
        <div className="LoaderSpinner">
          <BounceLoader
            color={"#607fe6"}
            loading={Loading}
            speedMultiplier={2}
            size={50}
          />
          <div className="fw-semibold">Loading... Please wait.</div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}
